<auth-layout title="Upload Documentation"
             type="SIGNUP"
             subTitile=""
             [isHiddenImage]="true"
             [hideHeader]="true">
  <div class="login-page">
    <div class="login-card">
      <div class="login-header">
        <h2>Upload Documents</h2>
        <p class="subtitle">Upload the required documents to complete your profile.</p>
      </div>

      <form class="login-form">
        <div class="form-group">
          <p class="owner">Business Documents</p>

          <div class="d-flex justify-content-between"
               *ngFor="let item of pickupDocumentVerification; let i = index">
            <div class="w-100">
              <label class="for-label">{{ item.name }}</label>
              <div class="for-validation text-danger" *ngIf="!item.pdf">
                <span class="yy">*</span>
                <ng-container *ngIf="isPDF(item.name); else imgAllowed">
                  (Only PDF or DOCX files are allowed).
                </ng-container>
                <ng-template #imgAllowed>
                  (Only PDF, DOCX, JPG, or PNG files are allowed).
                </ng-template>
              </div>
              <div class="form-group">
                <input *ngIf="isPDF(item.name)"
                       type="file"
                       [attr.id]="'fileInput_'+i"
                       accept=".pdf,.docx"
                       class="form-control custom-file-input"
                       (change)="uploadImg($event, item.key, i)">
                <input *ngIf="!isPDF(item.name)"
                       type="file"
                       [attr.id]="'fileInput_'+i"
                       accept=".pdf,.docx,.jpg,.png,.jpeg"
                       class="form-control custom-file-input"
                       (change)="uploadImg($event, item.key, i)">
              </div>
            </div>
          </div>
        </div>

        <div class="form-group submit-div">
          <div class="d-flex justify-content-center">
            <button class="btn btny for-login mr-3"
                    type="button"
                    (click)="goBack()">
              Back
            </button>
            <button class="btn btny for-login"
                    type="submit"
                    [disabled]="flag"
                    *ngIf="!loading"
                    (click)="load(); imgeUplode2()">
              Submit
            </button>
            <button class="btn btny for-login op05"
                    type="submit"
                    *ngIf="loading && uploadedDocument != totalDocument">
              Document uploaded {{uploadedDocument}}/{{totalDocument}}
            </button>
            <button class="btn btny for-login op05"
                    type="submit"
                    *ngIf="loading && uploadedDocument == totalDocument">
              Loading...
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</auth-layout>